export default __webpack_public_path__ + "static/media/scott.3bfe1ef3.jpeg";